import { render, staticRenderFns } from "./DLink.vue?vue&type=template&id=2c0f1c92&scoped=true&"
import script from "./DLink.vue?vue&type=script&lang=js&"
export * from "./DLink.vue?vue&type=script&lang=js&"
import style0 from "./DLink.vue?vue&type=style&index=0&id=2c0f1c92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f1c92",
  null
  
)

export default component.exports